<template>

  <div class="container">
    <headComponent/>

    <main>
      <div class="content"  v-if="$route.name === 'Links'" >
        <h1>Welcome to the Links Page</h1>
        <p>This is your links page of our application.</p>
        <LinksTableComponent/>
      </div>

      <div v-if="$route.name === 'adminlinks'">
        <h1>Welcome to the admin Links Page</h1>
        <p>This is all links of application.</p>
        <AdminLinksTableComponent/>
      </div>
    </main>

    <FooterComponent/>
  </div>
</template>

<script>
import HeadComponent from '@/components/views/head/HeadComponent.vue'
import FooterComponent from "@/components/views/footer/FooterComponent.vue";
import LinksTableComponent from "@/components/views/links/LinksTableComponent.vue";
import AdminLinksTableComponent from "@/components/views/links/AdminLinksTableComponent.vue";

export default {

  name: "linksComponent",
  /**
   * Object defining the components used in this application.
   * Each key corresponds to a registered component that can be used within the Vue template.
   *
   * @property {object} HeadComponent - A component representing the header section of the application.
   * @property {object} FooterComponent - A component representing the footer section of the application.
   * @property {object} LinksTableComponent - A component to display a table of links or similar data.
   * @property {object} AdminLinksTableComponent - A specialized component to display links in an administrative view.
   */
  components: {
    HeadComponent,
    FooterComponent,
    LinksTableComponent,
    AdminLinksTableComponent
  }
}
</script>

<style>
.option-button {
  width: 120px;
  height: 40px;
  text-align: center;
}

td img {
  max-width: 40px;
  height: auto;
}

.swal2-modal {
  width: 350px !important;
  height: 350px !important;
}

.cursor-pointer {
  cursor: default;
}

.copied-text {
  color: red;
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
}

</style>
